import { MarketItemViewModel } from '~/lib/data-contract';
import Check from '$icons/check.svg';
import { signOut } from 'next-auth/react';
import { useClub } from '~/features/club';
import { MediaImage, Typography } from '~/shared/components';
import { clsx } from 'clsx';
import styles from './market.module.css';

type Props = MarketItemViewModel & {
    active?: boolean;
};

export const Market = (props: Props) => {
    const { countryName, languageName, currency, active, locale, countryKey } = props;
    const {
        isAuthenticated,
        //    toggleSignInActive
    } = useClub();

    const handleMarketClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        signOut({ callbackUrl: `/${locale}` });
    };

    return (
        <a
            href={`/${locale}`}
            {...(isAuthenticated ? { onClick: handleMarketClick } : {})}
            className={clsx(styles.marketLink, 'hover-effect-underline-center', {
                [styles.active]: active,
            })}
        >
            <MediaImage
                src={`/assets/flags/${countryKey?.toLowerCase()}.png`}
                height="20"
                width="30"
                alt={countryName ?? ''}
                loading="lazy"
            />
            <div className={styles.marketText}>
                <Typography variant="body" as="span">
                    {countryName} {currency ? ` - ${currency}` : undefined}
                </Typography>
                <Typography variant="body" as="span">
                    {languageName}
                </Typography>
            </div>
            {active && <Check />}
        </a>
    );
};
